export default __webpack_public_path__ + "media/images/6-dogs-4fe3c2826bdedf6c57fc6def60a7764e.svg";